import { WeaTools } from 'ecCom'

export const getKQReport = params => {
  return WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportInfo', 'POST', params);
}

export const getKQCarendarReport = params => {
  return WeaTools.callApi('/api/hrm/kq/report/getHrmKQMonthReportInfo', 'POST', params);
}

export const getTableData = params => {
  return WeaTools.callApi('/api/hrm/kq/report/getHrmKQReportDetialInfo', 'POST', params);
}

export const getHrmNewWorkflwList = params => {
  return WeaTools.callApi('/api/hrm/kq/report/getHrmNewWorkflwList', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/checking.js